module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAAAAXNSR0IArs4c6QAAAMJJREFUKBWdkCEOhDAURAeynADRNCQcAYNGkx4CwyEIB+AsXAZDRVNZiQCBQNWw9CewZrts+KZp5r/OTIP9GDyY8AFDyOsE27ZFHMfn1Xu6gE3T4HJkjCHPcy/ghLIsEUUR7Vzgv1XPPYq6LAvGcUSSJEjT1OuqtYaUEtZaBMcLe9d1qKoKYXgF8MLrukIpBXI0xqCuawghvIAT5nnGMAxkQqArvW0bwb/IaZrQ9z2Kovj8qoPvhnOOLMtojTreAd/0N5TlRj/EzA1vAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/exterior.png
// module id = 506
// module chunks = 0